import { getAnalytics, logEvent } from "firebase/analytics";

export const logAnalytics = (type, details) => {
  logEvent(getAnalytics(), type, details)
};

